/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { APIDataProvider, ApiPaths, TApiResponse } from '../../../api';
import { IGroupTutorRate } from '.';

const apiDataProvider = new APIDataProvider();

export const getGroupTutorRates = createAsyncThunk(
  '/user/group-tutor-rates/list',
  async () => {
    const path = `${ApiPaths.groupTutorRates}`;

    const response = await apiDataProvider.get<TApiResponse<IGroupTutorRate[]>>(
      path
    );

    return response.data;
  }
);
